import {
  AboutScreen,
  SettingsScreen,
  DMToolsScreen,
  DiceRollScreen
} from "../components/Screens";
import { AUTHLEVEL } from "./utils";

import CasinoIcon from "@material-ui/icons/Casino";
import FunctionsIcon from "@material-ui/icons/Functions";
import SettingsIcon from "@material-ui/icons/Settings";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";

// Appname for permissions, also the path to app URL/controller
export const appName = `diceroller`;

// List of App Screens
export const UI = [
  {
    component: DiceRollScreen,
    label: `Dice Box`,
    icon: CasinoIcon,
    auth: AUTHLEVEL.free
  },
  {
    component: DMToolsScreen,
    label: `GM Tools`,
    icon: FunctionsIcon,
    auth: AUTHLEVEL.paid
  },
  {
    component: SettingsScreen,
    label: `Settings`,
    icon: SettingsIcon,
    auth: AUTHLEVEL.free
  },
  {
    component: AboutScreen,
    label: `About/Contact`,
    icon: ChatBubbleIcon,
    auth: AUTHLEVEL.free
  }
];

// Paths to Sound Files
const numbers_of_dice = [1, 2, 3, 4, 5, 6, 16];
export const sounds = numbers_of_dice.reduce((acc, number) => {
  const key1 = `${number}_standard_v1`;
  const key2 = `${number}_standard_v2`;
  const key3 = `${number}_standard_v3`;
  return {
    ...acc,
    [key1]: [`sounds/${key1}.webm`, `sounds/${key1}.mp3`],
    [key2]: [`sounds/${key2}.webm`, `sounds/${key2}.mp3`],
    [key3]: [`sounds/${key3}.webm`, `sounds/${key3}.mp3`]
  };
}, {});
